/* @flow */

import glamorous from 'glamorous';
import { IN_PROGRESS, IN_MANUAL_REVIEW, IN_REVIEW, COMPLETED } from 'app/constants/challengeStatusTypes';

const Dot = glamorous.span(({ statusId, theme }) => ({
  backgroundColor: {
    [IN_PROGRESS]: theme.color.success,
    [IN_MANUAL_REVIEW]: theme.color.success,
    [IN_REVIEW]: theme.color.warning,
    [COMPLETED]: theme.color.danger,
  }[statusId] || theme.color.success,
  borderRadius: '50%',
  display: 'block',
  height: 10,
  width: 10,
}));


export default Dot;
